import {
  OmsColumnType,
  OmsFilterOperator,
} from "../../lusca-search-api/generated-src";

export function comparisonLabel(
  operator: OmsFilterOperator,
  type: OmsColumnType = "string"
): string {
  const temporal = type === "date" || type === "datetime";
  return {
    eq: "Equals",
    ne: "Does not equal",
    contains: "Contains",
    notContains: "Does not contain",
    in: "Is one of",
    notIn: "Is not one of",
    gt: temporal ? "After" : "Greater than",
    gte: temporal ? "On or after" : "At least",
    lt: temporal ? "Before" : "Less than",
    lte: temporal ? "On or before" : "At most",
    isNull: "Is null",
    isNotNull: "Is not null",
  }[operator];
}

export function columnValueError(
  type: OmsColumnType,
  operator: OmsFilterOperator,
  value?: string,
  values?: string[]
): string | undefined {
  if (operator === "isNull" || operator === "isNotNull") return undefined;
  if (operator === "in" || operator === "notIn") {
    if (
      type !== "string" ||
      !values?.length ||
      values.length > 100 ||
      new Set(values).size !== values.length ||
      values.some((item) => [...item].length > 512 || item === "\\N")
    )
      return "Select 1–100 distinct text values.";
    return undefined;
  }
  const text = value || "";
  if (["contains", "notContains"].includes(operator) && !text)
    return "Enter text to search for.";
  if ([...text].length > 512) return "Use 512 characters or fewer.";
  if (
    type === "number" &&
    !/^[+-]?(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i.test(text.trim())
  )
    return "Enter a valid number.";
  if (type === "date" || type === "datetime") {
    const calendarDate = text.slice(0, 10);
    const date = new Date(`${calendarDate}T00:00:00Z`);
    if (
      !/^\d{4}-\d{2}-\d{2}$/.test(calendarDate) ||
      calendarDate.startsWith("0000") ||
      !Number.isFinite(date.getTime()) ||
      date.toISOString().slice(0, 10) !== calendarDate
    )
      return "Enter a valid date in YYYY-MM-DD format.";
    if (type === "date" && text !== calendarDate)
      return "Enter a date in YYYY-MM-DD format.";
    if (
      type === "datetime" &&
      (!/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)?$/.test(
        text
      ) ||
        !Number.isFinite(Date.parse(text)))
    )
      return "Enter a valid ISO date and time.";
  }
  return undefined;
}

export function fileSize(bytes: number): string {
  const unit = [
    { bytes: 1_000_000_000_000, label: "TB" },
    { bytes: 1_000_000_000, label: "GB" },
    { bytes: 1_000_000, label: "MB" },
    { bytes: 1_000, label: "kB" },
  ].find((candidate) => bytes >= candidate.bytes);
  if (!unit) return `${bytes.toLocaleString()} B`;
  return `${(bytes / unit.bytes).toLocaleString(undefined, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })} ${unit.label}`;
}
